import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import DataTable from 'react-data-table-component';
import { walletServices } from "../services/WalletService";
import InputText1 from "./InputText1";
import SearchBar from "./SearchBar";
import LoadingModal from "./LoadingModal";
import { adminServices } from "../services/AdminServices";
import { formatCurrency } from "../tools/tool";

const customStyles = { 
    overlay: { 
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    }, 
    content: {
        width: '80%', margin: 'auto', 
        height : '90%'
      
    },
 };

const PDLList = ({token,isOpen, onClose ,selectedInfo, type})=>{
    const [selectedData, setSelectedDate] = useState(null);
    const [clients, setClients] = useState(null);
    const [data, setData] = useState(null);
    const [columns, setColumns] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    let limit = 10;
    const [offset, setOffset] = useState(0);


    useEffect(()=>{
        if(searchQuery == ""){
            getPDLProfiles();
        }
        else{
            handleSearch();
        }
    },[offset])

  const handleSearchChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
  };

  const handleSearch = async ()=>{
          
          if(searchQuery === ''){
              setOffset(0);
              setFilteredData([]);
              await getPDLProfiles();
              return;
          }
          setLoading(true);
          await adminServices.getData('clients/search?query=' + searchQuery +`&offset=${offset}&limit=${limit}`).then(response => {
            if(response.status === 200){
              setData(response.data.clients);
              setFilteredData(response.data.clients);
              setTotalRecords(response.data.totalRecord);
              setLoading(false);
            }
          })
    }

    const getPDLProfiles = async ()=>{
        await walletServices.pdlList(limit,offset).then((r)=>{
            setData(r.data.clients);
            setFilteredData(r.data.clients);
            setTotalRecords(r.data.totalRecord);
            var _col = [
                { name: 'ID', selector: data=>data.id, sortable: true },
                { name: 'PDL Number', selector: data=>data.pdlNumber, sortable: true },
                { name: 'First Name', selector: data=>data.firstName, sortable: true },
                { name: 'Middle Name', selector: data=>data.middleName, sortable: true },
                { name: 'Last Name', selector: data=>data.lastName, sortable: true },
                { name: 'Gender', selector: data=>data.gender, sortable: true },
                { name: 'Facility Number', selector: data=>data.facilityNumber, sortable: true },
            ]
            
            if (type === "pdltomerchant") {
                _col.push({ name: 'Wallet Balance', selector: data=>formatCurrency(data.walletAmount), sortable: true });
            }
            setColumns(_col);
            setLoading(false);
        }).catch((r)=>{
            if(r.response.status === 401){
                window.location.href="/"
            }
        });
    }

    const handleSelectedRow = (row)=>{
        //console.log(row);
    }

    return (
            <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}
            >
        <LoadingModal show={loading} message={"Loading...."}/>
        <div style={{display:"flex",justifyContent:'space-between',zIndex:999}}>
                <h3>PDL List</h3>
                <button style={{backgroundColor:'#fff',
                    borderColor:'#d2d2d2',
                    color:'#555',
                    borderRadius:100,
                    fontSize:20,
                    fontWeight: 'bolder',
                    fontFamily: 'monospace',
                    borderWidth:0}}
                    onClick={onClose}
                    >
                        x
                    </button>
        </div>
                
        <div>
            <div className="row">
                <div className="col">
                    <SearchBar 
                        onChange={handleSearchChange}
                        value={searchQuery}
                        placeholder="Search PDL"

                    />

                    <button className="btn btn-secondary btn-xs" onClick={handleSearch}>
                        <i className="fa fa-search"></i> Search
                    </button>

                </div>
                <div className="col-auto">
                    <button className="btn btn-xs" onClick={
                    async ()=>{
                        if (offset > 0){
                        let ofset = offset - limit;
                        setOffset(ofset);
                        setLoading(true);
                        setFilteredData([]);
                        //await getPDLProfiles();
                        }
                    }
                    }>
                        <i class='fa fa-arrow-left'></i>
                    </button>
                   <span>
                    Page {Math.floor(offset / limit) + 1} of {Math.ceil(totalRecords / limit)}
                    </span>
                    <button className="btn btn-xs" onClick={ async ()=>{
                    if ((offset + limit) < totalRecords){
                        let ofset = offset + limit;
                        setOffset(ofset);
                        setLoading(true);
                        setFilteredData([]);
                        //await getPDLProfiles();
                    }
                    }}>
                        <i class='fa fa-arrow-right'></i>
                    </button>
                </div>
            </div>

            <DataTable 
                columns={columns}
                data={filteredData}
                pagination={false}
                highlightOnHover
                onRowClicked={selectedInfo}
                striped
                pointerOnHover
                responsive
                persistTableHead
            >

            </DataTable>
        </div>

</Modal>
    )
}

export default PDLList;